import React from 'react';
import { showModal } from 'lib/components/Modal';
import Dialog from 'lib/components/Dialog';
import toast from 'lib/utils/toast';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import msdkUtil from 'lib/utils/MSDK';
import { isAllowedDomainUrl } from 'lib/utils/util';
import { COMMON_MSG } from 'lib/constants/error';
import './index.scss';

const JumpUrl = (params) => {
  if (!params?.prizeUrl) {
    toast.info(COMMON_MSG);
    return null;
  }
  let { prizeUrl } = params;
  const { prizeName } = params;
  const handleJump = () => {
    report(ATTA_REPORT.MULTIPLE_LOTTERY.LOTTERY_REDIRECT_TO_THIRD_PARTY);

    if (msdkUtil.isMSDK) {
      const search = new URLSearchParams(location.search);
      // 只把登录态传给flow.qq.com和igame.qq.com域名
      if (isAllowedDomainUrl(prizeUrl)) {
        prizeUrl += (prizeUrl?.includes('?') ? '&' : '?') + search.toString();
      }
    }
    window.location.href = prizeUrl;
  };
  return (<Dialog title='-如何领取-' confirmButtonText='前往领取' confirmCallback={handleJump}>
    <div className="tips-modal__content">
      <img src='https://obd.gtimg.com/flow/flow-static/images/qqicon.png' className='qq_icon'></img>
      <div>{prizeName}</div>
    </div>
  </Dialog>);
};

export const showOrderJumpUrlModal = params => showModal(<JumpUrl {...params} />);

export default JumpUrl;
